import { Injectable } from '@angular/core';
import { ADMIN_ROUTE_CONSTANTS } from '@shared/constants/routes/admin-routes.constants';
import {MenuItem} from 'primeng/api';
import { COMMUNITY } from '@shared/constants/menu/admin/menu-admin-comunity-constants';
import { FINANCE } from '@shared/constants/menu/admin/menu-admin-finance-constants';
import { OPERATIONS } from '@shared/constants/menu/admin/menu-admin-operations-constants';
import { MARKETPLACE } from '@shared/constants/menu/admin/menu-admin-marketplace-constants';
import { INTELLIGENCE } from '@shared/constants/menu/admin/menu-admin-intelligence-constants';
import { CONFIGURATION } from '@shared/constants/menu/admin/menu-admin-configuration-constants';

@Injectable({ providedIn: 'root' })
export class MenuAdminService {
  buildMenu(): MenuItem[] {
    const adminBase = `/${ADMIN_ROUTE_CONSTANTS.path}`;



    const dashboard: MenuItem = {
      label: 'MENU_ADMIN.DASHBOARD',
      icon: ADMIN_ROUTE_CONSTANTS.dashboard.data.icon,
      hasSubmenu: false,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.dashboard.path}`
    };


    return [
      dashboard,
      FINANCE,
      OPERATIONS,
      COMMUNITY,
      MARKETPLACE,
      INTELLIGENCE,
      CONFIGURATION
    ];
  }
}


